module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "toc_marker-3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("A WINLOCK PRESS BOOK")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("ISBN: 978-1-61868-759-3ISBN ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("(eBook): 978-1-61868-758-6")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("PUBLISHED AT SMASHWORDS")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("THE HIGHWAY")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("The Reanimates")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("Book 2")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("© 2015 by J. Rudolph")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("All Rights Reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("Edited by "), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "http://www.moniquehappy.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Monique Happy Editorial Services")])]), _c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "http://www.coversbychristian.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Covers by Christian")])]), _c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("This book is a work of fiction. People, places, events, and situations are the product of the author’s imagination. Any resemblance to actual persons, living or dead, or historical events, is purely coincidental. No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means without the written permission of the author and publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_c('span', [_c('img', {
    staticClass: "frame",
    attrs: {
      "alt": "Image273939.JPG",
      "src": "OEBPS/image/Image273939_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "http://winlockpress.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Join Winlock’s spam-free mailing list to find out about the latest releases and giveaways.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-centered"
  }, [_vm._v("Please visit "), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "https://www.facebook.com/JRudolphAuthor?fref=ts",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("J. Rudolph’s Author Page on Facebook")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4886db0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/highway-3.vue
// module id = 66
// module chunks = 0